module.exports = __webpack_public_path__ + "static/media/U1-T2-1-1h.7e03d948.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-1-1h.mp3
// module id = 508
// module chunks = 0